<template>
  <div>
      <v-parallax
        height="200"
        src="../assets/Care/parallax.jpg"
      >
        <v-row class="ma-16 text-center font-weight-bold">
          <v-col cols="12">
            <div color="white" class="d-flex justify-center"><v-sheet rounded class="ma-1 pa-1 text-h5">W jaki sposób pielęgnować swoją kołdrę z runa Alpak?</v-sheet></div>
          </v-col>
        </v-row>
      </v-parallax>
      <v-row class="mt-16 mb-8">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <p class="text-h6">Pielęgnacja kołder z runa alpak jest istotna, aby utrzymać ich jakość i zachować trwałość. Oto kilka wskazówek dotyczących pielęgnacji:</p>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
      <v-row class="mt-16 mb-8">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <p class="text-h6"> <v-icon icon="mdi-star-circle-outline" color="primary"></v-icon> Częste wietrzenie</p>
          <p class="text-subtitle-1 font-weight-light">Regularnie wietrz kołdrę, aby pozbyć się ewentualnych zapachów i utrzymać świeżość.</p>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <p class="text-h6"> <v-icon icon="mdi-star-circle-outline" color="primary"></v-icon> Unikaj prania</p>
          <p class="text-subtitle-1 font-weight-light">Kołdry z runa alpak nie wymagają prania i nie jest ono zalecane. W miarę możliwości pierz kołdrę tylko w wyjątkowych sytuacjach (rozlanie cieczy itp.), aby nie narazić runa na nadmierne zużycie.</p>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <p class="text-h6"> <v-icon icon="mdi-star-circle-outline" color="primary"></v-icon> Delikatne pranie</p>
          <p class="text-subtitle-1 font-weight-light">Gdy konieczne jest pranie, stosuj delikatny program prania w pralce z użyciem łagodnego detergentu i temperaturze maksymalnie 30 stopni.</p>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <p class="text-h6"> <v-icon icon="mdi-star-circle-outline" color="primary"></v-icon> Czyszczenie punktowa</p>
          <p class="text-subtitle-1 font-weight-light">Alternatywą dla prania jest czyszczenie punktowe przy użyciu zimnej wody. Jest to szczególnie ważne, aby uniknąć deformacji i utraty właściwości termicznych runa alpak.</p>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <p class="text-h6"> <v-icon icon="mdi-star-circle-outline" color="primary"></v-icon> Unikaj wirowania</p>
          <p class="text-subtitle-1 font-weight-light">Podczas prania w pralce wybierz program bez wirowania lub jak najniższym jego poziomem. Pamiętaj, że wirowanie może uszkodzić alpakowe runo i zepsuć jego właściwości.</p>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <p class="text-h6"> <v-icon icon="mdi-star-circle-outline" color="primary"></v-icon> Unikaj suszenia w suszarce</p>
          <p class="text-subtitle-1 font-weight-light">Nie susz kołdry z runa alpak w suszarce bębnowej. Wysoka temperatura i intensywne ruchy mogą uszkodzić włókna.</p>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <p class="text-h6"> <v-icon icon="mdi-star-circle-outline" color="primary"></v-icon> Chron przed bezpośrednim światłem słonecznym</p>
          <p class="text-subtitle-1 font-weight-light">Unikaj bezpośredniego wystawiania kołdry na słońce, aby zapobiec blaknięciu kolorów i utracie miękkości włókien.</p>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <p class="text-h6"> <v-icon icon="mdi-star-circle-outline" color="primary"></v-icon> Chron przed owadami</p>
          <p class="text-subtitle-1 font-weight-light">Przechowuj kołdry w miejscu, które jest chronione przed owadami. Możesz także używać specjalnych worków lub pojemników, aby zabezpieczyć je przed kurzem i insektami.</p>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <p class="text-h6"> <v-icon icon="mdi-star-circle-outline" color="primary"></v-icon> Regularna pielęgnacja</p>
          <p class="text-subtitle-1 font-weight-light">Staraj się utrzymywać kołdrę w czystości, regularnie usuwając ewentualne plamy. Im szybciej zareagujesz na plamy, tym łatwiej będzie je usunąć.</p>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
  </div>
</template>